import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";

import messages from "../../../../../assets/locale/messages";
import { UIIcon } from "../../../../ui";

import "./PublishEventModal.scss";

/** Event logo, name and staff requested — shared by the publish and save-as-draft popups. */
const EventSummaryBox = ({ eventSummary }) => {
  const lang = useSelector((state) => state.locale.lang);
  const t = messages[lang].events.creatEvent.publishEventModal;

  return (
    <div className="publish-event-modal__summary">
      <div className="publish-event-modal__summary-logo">
        {eventSummary.image_url ? (
          <img src={eventSummary.image_url} alt="" />
        ) : (
          <UIIcon name="events" width={18} height={18} />
        )}
      </div>
      <div>
        <Typography className="publish-event-modal__summary-title text-label-sm" component="h3">
          {eventSummary.name || t.eventFallbackName}
        </Typography>
        <Typography className="publish-event-modal__summary-meta text-body-xxs" component="p">
          {t.staffRequested.replace("{count}", eventSummary.staffRequested || 0)}
        </Typography>
      </div>
    </div>
  );
};

EventSummaryBox.propTypes = {
  eventSummary: PropTypes.shape({
    name: PropTypes.string,
    image_url: PropTypes.string,
    staffRequested: PropTypes.number,
  }),
};

EventSummaryBox.defaultProps = {
  eventSummary: {},
};

export default EventSummaryBox;
